export default __webpack_public_path__ + "static/media/3172.b3b7fe52.svg";